import React, { useMemo } from 'react'
import { Container, Grid, Segment } from 'semantic-ui-react'

import PanelItems from '../../containers/PanelItems/index.nehr'

import { providerItems } from '@enlyt/base/constants/Items/MyHealth/index.nehr.js'
import useMediaQuery from 'hooks/useMediaQuery'

import { defaultStyles as styles } from './styles'

export const NehrProvidersComponent = ({ isEhrSigned }) => {
  const { isMobile, isTablet } = useMediaQuery()

  const columns = useMemo(() => {
    if (isEhrSigned) {
      return isMobile ? 1 : isTablet ? 3 : 4
    }

    return isMobile ? 1 : 3
  }, [isMobile, isTablet, isEhrSigned])

  return (
    <Segment style={styles.container} vertical>
      <Container style={styles.content}>
        <Grid columns={columns}>
          <p style={styles.nehrComment}>
            To schedule a visit with one of the providers we&apos;ll need to
            connect to your provider&apos;s medical record system, connect to:
          </p>
          <PanelItems items={providerItems} />
        </Grid>
      </Container>
    </Segment>
  )
}
